<template>
  <div class="dialog-overlay" v-if="visible">
    <div class="dialog">
      <div class="dialog-header">
        <span class="dialog-title">Edit Note</span>
        <button @click="closeDialog" class="close-button">&times;</button>
      </div>
      <form @submit.prevent="saveNote" class="form-container">
        <!-- Note Input -->
        <div class="form-group">
          <label for="note">Note:</label>
          <textarea
            v-model="localTransaction.note"
            id="note"
            rows="4"
            required
          ></textarea>
        </div>

        <!-- Submit Button -->
        <div class="form-group">
          <button type="submit" class="save-button">Save</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    transaction: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localTransaction: { ...this.transaction },
    };
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    saveNote() {
      this.$emit('save', this.localTransaction);
    },
  },
  watch: {
    transaction(newTransaction) {
      this.localTransaction = { ...newTransaction };
    },
  },
};
</script>

<style>
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.dialog {
  background: white;
  padding: 20px;
  border-radius: 5px;
  width: 300px;
  user-select: none;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.dialog-title {
  font-size: 1.2em;
  font-weight: bold;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5em;
  cursor: pointer;
}

.form-container {
  display: flex;
  flex-direction: column;
}

.form-group {
  margin-bottom: 15px;
}

textarea {
  width: 95%;
  margin-right: 8px;
  padding: 10px;
  font-size: 1em;
  border: 1px solid #ccc;
  border-radius: 5px;
  user-select: text !important;
}

.save-button {
  padding: 10px 20px;
  font-size: 1em;
  border: none;
  background-color: #007bff;
  color: white;
  border-radius: 5px;
  cursor: pointer;
}

.save-button:hover {
  background-color: #0056b3;
}
</style>
